import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/layout/Header';
import Sidebar from '../components/layout/Sidebar';
export default function RootLayout() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();
    // Auto-close the mobile menu on navigation
    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location.pathname]);
    return (_jsxs("div", { className: "min-h-screen bg-gray-50", children: [_jsx(Header, { onMenuToggle: () => setIsMobileMenuOpen((open) => !open), showMenuButton: true }), _jsx(Sidebar, { mobileOpen: isMobileMenuOpen, onMobileClose: () => setIsMobileMenuOpen(false) }), _jsx("main", { className: "pt-16 lg:ml-64", children: _jsx("div", { className: "mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8", children: _jsx(Outlet, {}) }) })] }));
}
